import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import React from 'react'
import { useIntl } from 'react-intl'
import type {
  PaginationColor,
  PaginationSize,
  PaginationVariant,
} from './Pagination'
import { sizes, variants } from './Pagination'

interface NavigationItemProps {
  /**
   * The color scheme of the pagination component
   */
  color: PaginationColor
  /**
   * If true, the navigation item is disabled
   */
  disabled: boolean
  /**
   * Callback fired when the navigation item is activated
   */
  onClick: () => void
  /**
   * The label for the navigation action
   */
  label: string
  /**
   * The size of the navigation component
   */
  size: PaginationSize
  /**
   * The visual style variant of the navigation component
   */
  variant: PaginationVariant
}

function NavigationItem({
  children,
  color,
  disabled,
  label,
  onClick,
  size,
  variant,
}: PropsWithChildren<NavigationItemProps>): JSX.Element {
  const intl = useIntl()

  return (
    <li>
      <button
        aria-label={intl.formatMessage(
          { id: 'Pagination.go_to_page' },
          { label },
        )}
        className={clsx(
          'flex items-center justify-center rounded-full text-black-60 text-sm font-normal leading-relaxed disabled:bg-transparent disabled:cursor-not-allowed disabled:text-black-25 focus:outline-none',
          sizes[size],
          variants[variant][color].unselected,
        )}
        disabled={disabled}
        onClick={onClick}
        type="button"
      >
        <span className="flex items-center justify-center w-4 h-4">
          {children}
        </span>
      </button>
    </li>
  )
}

export default NavigationItem
